export default __webpack_public_path__ + "static/media/image1.ed02766c.png";